module.exports = lib_react_redux;